import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../Components/auth/firebaseConfig'; // correct path to your Firestore init

// Cache to avoid refetching the same board name repeatedly
const boardNameCache = {};

const enrichCard = async (item) => {
  // Resolve boardName from boardId if needed
  let boardName = '';
  if (item.boardId) {
    if (boardNameCache[item.boardId]) {
      boardName = boardNameCache[item.boardId];
    } else {
      const boardSnap = await getDoc(doc(db, 'boards', item.boardId));
      if (boardSnap.exists()) {
        boardName = boardSnap.data().boardName || '';
        boardNameCache[item.boardId] = boardName;
      }
    }
  }
//Matched the export Report functionality format similar to what has been implemented in Card Export functionality
  return {
    //CardID: item.id || item.cardId || '',
    Summary: item.taskName || '',
     Description: item.description || '',
     CardStatus: item.cardStatus || '',
     DueDate: item.dueDate || '',
    CardType: item.cardType || '',
    Estimate: item.estimate || '',
    Priority: item.priority || '',
    AcceptanceCriteria: item.acceptanceCriteria || '',
    BoardName: boardName,
    AssigneeEmail: item.assigneeEmail || '',
    ProjectName: item.cardProjectName || '',
     //BoardID: item.boardId || '',
    //AssigneeName: item.assigneeName || '',
   
    //CardCreatedBy: item.createdBy || item.cardCreatedByUserId || '',
    //CardCreatedOn: item.cardCreationDate.  //to add Due Date instead
      //? new Date(item.cardCreationDate).toLocaleString()
      //: '',
    //TenantID: item.tenantId || ''
  };
};

const formatProjectsOrBoards = (item, reportType) => {
  if (reportType === 'projects') {
    return {
      'Project Name': item.prjName || '',
      'Project Id': item.prjId || '',
      Description: item.description || '',
      Tenant_Id: item.tenantId || '',
      'Project Owner_Id': item.prjOwnerId || '',
      'Project Owner_Name': item.prjOwnerName || '',
      'Start Date': item.startDate || '',
      'Due Date': item.dueDate || '',
      Updated_At: item.updatedAt || '',
      Columns: (item.columns || []).join(', ')
    };
  } else if (reportType === 'boards') {
    return {
      'Assigned Groups': (item.assignedGroups || []).join(', '),
      'Board Active Status': item.boardActiveStatus || '',
      'Board Created By User_Id': item.boardCreatedByUserId || '',
      Board_Id: item.boardId || '',
      'Board Name': item.boardName || '',
      'Board Type': item.boardType || '',
      Description: item.boardDescription || '',
      'Board Creation Date': item.boardcreationDate || '',
      'Project Name': item.prjName || '',
      'Project Id': item.projectId || '',
      'Tenant Id': item.tenantId || '',
      Columns: (item.columns || []).join(', ')
    };
  }
  return item;
};

const formatData = async (data, reportType) => {
  if (reportType === 'cards') {
    const enriched = await Promise.all(data.map(enrichCard));
    return enriched;
  } else {
    return data.map((item) => formatProjectsOrBoards(item, reportType));
  }
};

export const generateExcel = async (data, fileName, reportType) => {
  if (!data || data.length === 0) {
    alert('No data available to generate the report.');
    return;
  }

  const formattedData = await formatData(data, reportType);
  const worksheet = XLSX.utils.json_to_sheet(formattedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Report');

  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

  saveAs(blob, `${fileName}.xlsx`);
};
